import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import numeral from 'numeral';

import { paramConverter } from 'modules/common';
import { getDate, dataConverter } from 'lib/commonLib';
import {
  ManageGoodsInfoReviewProduct,
  goodsinfoAdverList,
  reviewProductCount,
} from 'lib/api/goods';

import NewInput from 'components/atoms/NewInput';
import MbButton from 'components/atoms/MbButton';
import Avatar from 'components/atoms/Avatar';
import CurrentStatus from 'components/atoms/CurrentStatus';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewTableContainer from 'components/molecules/NewTable';
import TopTextArea from 'components/molecules/MbTable/TopTextArea';
import AutoComplete from 'components/molecules/NewSelectBox/AutoComplete';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';

const ProductManagementGoodsInfoReviewProcut = ({ location }) => {
  const { t } = useTranslation();
  const isPopPage = queryString.parse(location.search).isPop === '1';

  const convertKeys = ['adverId', 'sDate', 'eDate'];
  let initTempParams = {
    sDate: getDate(moment(moment().format('YYYY-MM-01'))),
    eDate: getDate(moment()),
    adverId: '',
    prdtCode: '',
    prdtNm: '',
    order: 'LAST_DATE',
    sort: 'desc',
  };
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  initTempParams = {
    ...initTempParams,
    ...newInitParams,
  };

  const [tempParams, setTempParams] = useState(initTempParams);
  const [params, setParams] = useState(initTempParams);
  const [subData, setSubData] = useState('');

  const [initialization, setInitialization] = useState(false);
  const [loading, setLoading] = useState(!!params['adverId']);
  const [adverList, setAdverList] = useState([]);

  const initSnackbar = {
    open: false,
    variant: '',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);

  useEffect(() => {
    goodsinfoAdverList()
      .then((response) => {
        const { data } = response.data;
        setAdverList(data);
      })
      .catch((error) => {
        setSnackbar({
          ...initSnackbar,
          open: true,
          variant: 'error',
          message: error,
        });
      });
    // eslint-disable-next-line
  }, []);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  useEffect(() => {
    if (loading) {
      reviewProductCount(
        paramConverter({
          ...params,
          adverId: !!params['adverId'] ? params['adverId'] : null,
          prdtCode: !!params['prdtCode'] ? params['prdtCode'] : null,
          prdtNm: !!params['prdtNm'] ? params['prdtNm'] : null,
        })
      )
        .then((response) => {
          const { data } = response.data;
          const newSubData =
            t('리뷰 수집 상품 수') +
            ' : ' +
            numeral(data.reviewCnt).format('#,##0') +
            t('개') +
            ' / ' +
            t('광고주의 웹 상품수') +
            ' : ' +
            numeral(data.shopCnt).format('#,##0') +
            t('개') +
            ' / ' +
            t('광고주의 모바일 상품수') +
            ' : ' +
            numeral(data.mobShopCnt).format('#,##0') +
            t('개');

          setSubData(newSubData);
        })
        .catch((error) => {
          setSnackbar({
            ...initSnackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        });
    }

    // eslint-disable-next-line
  }, [params]);

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setTempParams(initTempParams);
    setParams(initTempParams);
    setLoading(false);
    if (isPopPage && window.location.search !== '?isPop=1') {
      console.log('팝업 리셋');
      window.location.replace(window.location.pathname + '?isPop=1');
    }
  };

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleTempParams = (newParams, name) => {
    if (newParams[name] === '') {
      newParams[name] = '';
    }

    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };

  /**
   *  검색버튼 클릭시
   */
  const handleSubmit = () => {
    if (tempParams.adverId === null || tempParams.adverId === '') {
      setSnackbar({
        open: true,
        variant: 'error',
        message: t('광고주 ID는 필수 입력값 입니다') + '.',
      });
      setLoading(false);
    } else {
      setParams({
        ...params,
        ...paramConverter(tempParams),
      });
      setLoading(true);
    }
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    ADVER_ID: { orderFlag: false },
    PRDT_NM: { bodyStyle: { maxWidth: 150, wordBreak: 'break-all' } },
    PRDT_IMG: {
      makeHead: (headsMap) => {
        return t('상품이미지');
      },
      makeBody: (rowObj) => {
        return <Avatar src={rowObj['PRDT_IMG']} />;
      },
      bodyStyle: { width: 150 },
    },
    PRDT_URL: { bodyStyle: { maxWidth: 150, wordBreak: 'break-all' } },
    PRDT_REVW_AVG: { orderFlag: true },
    REG_DTTM: { orderFlag: true },
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDisplayFilter={false}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
        />
        <AutoComplete
          list={adverList}
          label={t('광고주ID')}
          name="adverId"
          valueKey="USER_ID"
          labelKey="USER_ID"
          getParam={handleTempParams}
          params={tempParams}
          type="filter"
        />
        <NewInput
          label={t('상품코드')}
          type="filter"
          name="prdtCode"
          params={tempParams}
          value={tempParams['prdtCode']}
          callBack={handleTempParams}
        />
        <NewInput
          label={t('상품명')}
          type="filter"
          name="prdtNm"
          params={tempParams}
          value={tempParams['prdtNm']}
          callBack={handleTempParams}
        />
        <MbButton onClick={handleSubmit} filterButton>
          {t('검색')}
        </MbButton>
      </NewFilterWrap>
      {loading ? (
        <>
          <TopTextArea subData={subData} />
          <NewTableContainer
            params={{
              ...params,
              adverId: !!params['adverId'] ? params['adverId'] : null,
              prdtCode: !!params['prdtCode'] ? params['prdtCode'] : null,
              prdtNm: !!params['prdtNm'] ? params['prdtNm'] : null,
            }}
            getParam={getParam}
            dataReqPromise={ManageGoodsInfoReviewProduct}
            customized={customized}
            useTotal={false}
            useFetch={false}
            useSearch={false}
            toolTip={
              '리뷰를 수집하고 있는 광고주의 상품 정보를 보실 수 있습니다.'
            }
          />
        </>
      ) : (
        <CurrentStatus type="noTable" />
      )}
      <SnackbarWrap
        open={snackbar.open}
        onClose={handleSnackBarClose}
        variant={snackbar.variant}
        message={snackbar.message}
      />
    </>
  );
};

export default withRouter(ProductManagementGoodsInfoReviewProcut);
